import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./MobileNavigation.css";
import { canAccessSales } from "./shootSalesModel";

export default function MobileNavigation() {
  const { currentUser, isAdmin, isSuperAdmin, logout } = useAuth();
  const { pathname } = useLocation();
  const [openPath, setOpenPath] = useState(null);
  if (!currentUser) return null;
  const open = openPath === pathname;
  const links = [["/banners", "Banners"], ["/my-hours", "My Hours"], ["/scheduler", "Schedule"], ["/stafflist", "Staff list"], ["/clientlist", "Client list"], ["/dayoffrequests", "Days off"]];
  if (canAccessSales(currentUser)) links.push(["/shoot-sales", "Shoot Sales"]);
  if (isAdmin) links.push(["/addclients", "Add clients"], ["/bookappointment", "Book appointment"], ["/activitylog", "Activity log"]);
  if (isSuperAdmin) links.push(["/management", "Staff management"], ["/signup", "Create account"]);
  return <nav className="mobile-navigation" aria-label="Mobile navigation" onKeyDown={event => {
    if (event.key === "Escape") {setOpenPath(null);document.getElementById("mobile-menu-toggle")?.focus();}
  }}>
    <div className="mobile-navigation-bar"><Link to="/my-schedule" onClick={() => setOpenPath(null)}>My Schedule</Link>
      {pathname.toLowerCase() === "/my-schedule" && <Link className="mobile-main-schedule" to="/scheduler" onClick={() => setOpenPath(null)}>Main schedule</Link>}
      <button id="mobile-menu-toggle" aria-expanded={open} aria-controls="mobile-navigation-links" onClick={() => setOpenPath(open ? null : pathname)}>{open ? "Close menu" : "Menu"}</button></div>
    {open && <div id="mobile-navigation-links" className="mobile-navigation-links">{links.map(([to, label]) => <Link key={to} to={to} aria-current={pathname.toLowerCase() === to ? "page" : undefined} onClick={() => setOpenPath(null)}>{label}</Link>)}<button onClick={() => {setOpenPath(null);logout();}}>Log out</button></div>}
  </nav>;
}
